import { interpolate } from '../../../global';
import type { ILanguageResources, ITranslationModule } from '../../../interfaces';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.webmodule-common.components.table.LitTable.';
  public static readonly paginator_first = `${Id.prefix}paginator.first`;
  public static readonly paginator_prev = `${Id.prefix}paginator.prev`;
  public static readonly paginator_next = `${Id.prefix}paginator.next`;
  public static readonly paginator_last = `${Id.prefix}paginator.last`;
  public static readonly paginator_loading = `${Id.prefix}paginator.loading`;
  public static readonly column1 = `${Id.prefix}column1`;
  public static readonly column2 = `${Id.prefix}column2`;
}

export class LangLitTable {
  private constructor() {}
  public static paginatorFirst(): string {
    return interpolate(Id.paginator_first);
  }
  public static paginatorPrev(): string {
    return interpolate(Id.paginator_prev);
  }
  public static paginatorNext(): string {
    return interpolate(Id.paginator_next);
  }
  public static paginatorLast(): string {
    return interpolate(Id.paginator_last);
  }
  public static paginatorLoading(): string {
    return interpolate(Id.paginator_loading);
  }
  public static column1(): string {
    return interpolate(Id.column1);
  }
  public static column2(): string {
    return interpolate(Id.column2);
  }
}

export class LitTableModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.paginator_first, 'First', 'First page button in paginator');
    register.add(Id.paginator_prev, 'Prev', 'Previous page button in paginator');
    register.add(Id.paginator_next, 'Next', 'Next page button in paginator');
    register.add(Id.paginator_last, 'Last', 'Last page button in paginator');
    register.add(Id.paginator_loading, 'Loading....', 'Loading message for row extension');
    register.add(Id.column1, 'Column1', 'Default column 1 title');
    register.add(Id.column2, 'Column2', 'Default column 2 title');
  }
}
